var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "60", height: "60", viewBox: "0 0 60 60" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd", stroke: "#258518", strokeWidth: "2" },
      React.createElement("path", { fill: "#FFF", d: "M12.232 9a2 2 0 0 0-1.916 1.425L9.844 12h40.312l-.472-1.575A2 2 0 0 0 47.768 9H12.232z" }),
      React.createElement("rect", { width: "42", height: "28", x: "9", y: "25", fill: "#FFF", rx: "1" }),
      React.createElement("rect", { width: "22", height: "16", x: "13", y: "32", rx: "1" }),
      React.createElement("rect", { width: "8", height: "16", x: "39", y: "37", rx: "1" }),
      React.createElement("path", { fill: "#FFF", d: "M7.344 20h45.312l-2.4-8H9.744l-2.4 8z" }),
      React.createElement("path", { fill: "#FFF", d: "M7.79 20a1 1 0 0 0-.994.89l-.302 2.72A3.052 3.052 0 0 0 9.528 27h.972a3.5 3.5 0 0 0 3.5-3.5V20H7.79zM14 20v3.5a3.5 3.5 0 0 0 3.5 3.5h1a3.5 3.5 0 0 0 3.5-3.5V20h-8zM22 20v3.5a3.5 3.5 0 0 0 3.5 3.5h1a3.5 3.5 0 0 0 3.5-3.5V20h-8zM30 20v3.5a3.5 3.5 0 0 0 3.5 3.5h1a3.5 3.5 0 0 0 3.5-3.5V20h-8zM38 20v3.5a3.5 3.5 0 0 0 3.5 3.5h1a3.5 3.5 0 0 0 3.5-3.5V20h-8zM46 20v3.5a3.5 3.5 0 0 0 3.5 3.5h.972a3.052 3.052 0 0 0 3.034-3.39l-.302-2.72a1 1 0 0 0-.994-.89H46z" }),
      React.createElement("rect", { width: "4", height: "1", x: "17.387", y: "38.315", rx: ".5", transform: "rotate(-40 19.387 38.315)" }),
      React.createElement("rect", { width: "4", height: "1", x: "21.613", y: "38.685", rx: ".5", transform: "rotate(-40 23.613 38.685)" }),
      React.createElement("path", { d: "M44 43h1v1h-1z" }),
      React.createElement("rect", { width: "46", height: "1", x: "7", y: "53", rx: ".5" })
    )
  );
});